import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-76ZLKEGJP5";

let initialized = false;

export const initGA = () => {
  if (initialized) return;
  // 自動のページビュー送信は切り、ルート変更時に sendPageView で明示送信する。
  // （SPAでは初回の自動送信とルート変更の送信が二重計上になるため）
  ReactGA.initialize(MEASUREMENT_ID, {
    gtagOptions: { send_page_view: false },
  });
  initialized = true;
};

export const sendPageView = (path) => {
  if (!initialized) return;
  ReactGA.send({ hitType: "pageview", page: path });
};

export const sendExternalLinkClick = (url) => {
  if (!initialized) return;
  ReactGA.event({
    category: "External Link",
    action: "click",
    label: url,
  });
};
